import { useRef as u, useState as i, useEffect as c } from "react";
import { CopilotSession as s } from "../session.js";
import { useStore as o } from "@nanostores/react";
function _({ shouldInitialize: t = !0 } = {}) {
  const e = u(new s()), [, r] = i({});
  c(() => ((e.current.isDestroying || e.current.isDestroyed) && (e.current = new s(), r({})), t && e.current.initialize(), () => {
    e.current.scheduleDestroy();
  }), [t]);
  const n = () => (e.current.scheduleDestroy(), e.current = new s(), t && e.current.initialize(), r({}), e.current);
  return Object.assign(e.current, { reset: n }), e.current;
}
function d(t) {
  return o(t.__status);
}
function m(t) {
  return o(t.__statefulMessages);
}
function C(t) {
  return o(t.__availableTools);
}
function S(t, e) {
  return o(t.__tools)[e]?.render;
}
export {
  C as useCopilotAvailableTools,
  m as useCopilotMessages,
  _ as useCopilotSession,
  d as useCopilotStatus,
  S as useCopilotToolRender
};
